import { createI18n } from 'vue-i18n'
import en from '../locales/en'
import tr from '../locales/tr'
import { installBrandTokens } from './brandTokens'

const i18n = createI18n({
    legacy: false, // Use Composition API mode
    locale: 'tr', // Default locale
    fallbackLocale: 'en',
    messages: {
        en,
        tr
    }
})

// Brand-token interpolation (cutover D1): resolve {{agencyName}}/{{agencyEmail}}/{{appName}}/
// {{brandName}} in every message source before vue-i18n's compiler sees it. Must run before any
// setLocaleMessage (backend i18n sync) so token-bearing strings never reach the user verbatim.
installBrandTokens(i18n)

export default i18n
